<template>
  <div data-type="input" class="input" :class="{ attachment }">
    <input
      :id="inputId"
      ref="inputPrice"
      v-capusta-money="currency"
      type="tel"
      :size="inputSize"
      :title="inputTitle"
      :class="{ 'invalid': $v.$error || this.error }"
      :placeholder="placeholder"
      :value="value"
      autocomplete="off"
      @change="handleInput"
      @focus="$emit('focus')"
    />
    <label :for="inputId">
      <span>{{ inputName }}</span>
    </label>
  </div>
</template>

<script>
import { requiredIf } from 'vuelidate/lib/validators';
import { isLessMaxAmount, isMoreMinAmount } from './CustomValidators';

import { formatAmount } from 'lib/utils/amount';

export default {
  name: 'InputPrice',
  props: {
    value: [Number, String],
    required: Boolean,
    inputName: String,
    inputTitle: String,
    inputId: String,
    inputSize: {
      type: Number,
      default() {
        return 12;
      },
    },
    minValue: {
      type: Number,
      default() {
        return 1000;
      },
    },
    maxValue: {
      type: Number,
      default() {
        return 999999999999999;
      },
    },
    error: Boolean,
    attachment: Boolean,
    commission: {
      type: Number,
      default: 0,
    },
    currency: {
      type: Object,
      required: true,
    },
  },
  validations() {
    return {
      value: {
        required: requiredIf(() => this.required),
        minValue: isMoreMinAmount(this.minValue, this.currency),
        maxValue: isLessMaxAmount(this.maxValue, this.commission, this.currency),
      },
    };
  },
  computed: {
    placeholder() {
      return formatAmount(0, this.currency);
    },
  },
  methods: {
    handleInput(e) {
      this.$emit('change', e.target.value.trim());
      this.$v.$touch();
    },
  },
};
</script>
